<template>
  <div
    v-if="currentMaterial"
    class="materials-widget"
  >
    <div class="materials-widget__logos">
      <img
        v-for="logo in currentMaterial.logotypes"
        v-lazy-load
        class="materials-widget__logo"
        :class="logo.modifier ? `materials-widget__logo--${logo.modifier}` : ''"
        :data-src="logo.src"
        :alt="logo.alt"
      >
    </div>
    <div class="materials-widget__links">
      <a
        class="materials-widget__link"
        :href="currentMaterial.downLoad.url.path"
        rel="noopener noreferrer"
        target="_blank"
      >
        <svg-download class="materials-widget__link-icon"></svg-download>
        {{ currentMaterial.downLoad.name }}
      </a>

      <s-document
        class="materials-widget__link"
        :link="currentMaterial.usageGuide.url.path"
      >
        <span>{{ currentMaterial.usageGuide.name }}</span>
      </s-document>
    </div>
  </div>
</template>

<script>

  import SvgDownload from '~/assets/icons/header/dropdown-menu/download.svg'
  import SvgDocument from '~/assets/icons/header/dropdown-menu/doc.svg'

  const materialsList = {
    en: [
      {
        title: 'Selectel logo',
        mode: 'selectel-logotypes',
        logotypes: [
          {
            modifier: 'bordered',
            src: require('~/assets/images/about/materials/selectel.png'),
            alt: ''
          },
          {
            modifier: '',
            src: require('~/assets/images/about/materials/selectel-dark.png'),
            alt: ''
          }
        ],
        downLoad: {
          externalTypeOfLink: true,
          name: 'Selectel logo',
          url: {
            path: 'https://files.selectel.ru/stylebook/selectel_logo_svg.zip',
            hash: null
          }
        },
        usageGuide: {
          externalTypeOfLink: true,
          name: 'Guidelines for the Selectel logo usage',
          url: {
            path: 'https://files.selectel.ru/stylebook/selectel-logobook.pdf',
            hash: null
          }
        }
      },
      {
        title: 'Selectel partners\' logo',
        mode: 'partners-logotypes',
        logotypes: [
          {
            modifier: 'bordered',
            src: require('~/assets/images/about/materials/selectel-partner.png'),
            alt: ''
          }
        ],
        downLoad: {
          externalTypeOfLink: true,
          name: 'Selectel partners\' logo',
          url: {
            path: 'https://files.selectel.ru/stylebook/selectel_partner_svg.zip',
            hash: null
          }
        },
        usageGuide: {
          externalTypeOfLink: true,
          name: 'Guidelines for partners\' logo usage',
          url: {
            path: 'https://files.selectel.ru/stylebook/selectel-partner-logobook.pdf',
            hash: null
          }
        }
      }
    ],
    ru: [
      {
        title: 'Логототип Selectel',
        mode: 'selectel-logotypes',
        logotypes: [
          {
            modifier: 'bordered',
            src: require('~/assets/images/about/materials/selectel.png'),
            alt: ''
          },
          {
            modifier: '',
            src: require('~/assets/images/about/materials/selectel-dark.png'),
            alt: ''
          }
        ],
        downLoad: {
          externalTypeOfLink: true,
          name: 'Логотип Selectel',
          url: {
            path: 'https://files.selectel.ru/stylebook/selectel_logo_svg.zip',
            hash: null
          }
        },
        usageGuide: {
          externalTypeOfLink: true,
          name: 'Руководство по использованию логотипа Selectel',
          url: {
            path: 'https://files.selectel.ru/stylebook/selectel-logobook.pdf',
            hash: null
          }
        }
      },
      {
        title: 'Логототип партнера Selectel',
        mode: 'partners-logotypes',
        logotypes: [
          {
            modifier: 'bordered',
            src: require('~/assets/images/about/materials/selectel-partner.png'),
            alt: ''
          }
        ],
        downLoad: {
          externalTypeOfLink: true,
          name: 'Логотип партнера Selectel',
          url: {
            path: 'https://files.selectel.ru/stylebook/selectel_partner_svg.zip',
            hash: null
          }
        },
        usageGuide: {
          externalTypeOfLink: true,
          name: 'Руководство по использованию логотипа партнеров',
          url: {
            path: 'https://files.selectel.ru/stylebook/selectel-partner-logobook.pdf',
            hash: null
          }
        }
      }
    ]
  }

  export default {
    name: 'MaterialsWidget',
    components: {
      SvgDownload,
      SvgDocument
    },
    props: {
      mode: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        materialsList: materialsList[this.$i18n.locale]
      }
    },
    computed: {
      currentMaterial() {
        return this.materialsList.find(material => material.mode === this.mode)
      }
    }
  }
</script>

<style lang="scss">
  .materials-widget {
    padding-top: 16px;
  }

  .materials-widget__logos {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
  }

  .materials-widget__logo {
    max-width: calc(50% - 6px);
    max-height: 40px;

    @media (max-width: $breakpoint-xxl) {
      height: 34px;
    }

    @media (max-width: $breakpoint-xl) {
      height: 42px;
    }

    &:not(:last-child) {
      margin-right: 12px;
    }

    &--bordered {
      box-shadow: inset 0 0 0 1px rgba(9, 36, 51, 0.1)
    }
  }

  .materials-widget__links {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @include text--sm;
  }

  .materials-widget__link {
    color: inherit;

    &.s-document {
      background-size: 14px;
    }

    &:not(:last-child) {
      margin-bottom: 16px;
    }

    &:hover {
      color: $secondary;

      .materials-widget__link-icon {
        fill: $secondary;
      }
    }
  }

  .materials-widget__link-icon {
    display: inline-block;
    width: 14px;
    margin-right: 7px;
    fill: $primary;
    transition: fill 0.2s;
  }
</style>